"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
// Favourite Editor should be Monaco Editor but its React Wrapper is currently
// not very stable
var react_codemirror2_1 = require("react-codemirror2");
require("codemirror/lib/codemirror.css");
require("codemirror/mode/xml/xml");
require("codemirror/mode/javascript/javascript");
require("blob");
var file_saver_1 = require("file-saver");
require("./CodeEditor.css");
var antd_1 = require("antd");
var Option = antd_1.Select.Option;
var _isEqual = require('lodash/isEqual');
var LocaleWrapper_1 = require("../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../locale/en_US"));
/**
 * The CodeEditor.
 */
var CodeEditor = /** @class */ (function (_super) {
    __extends(CodeEditor, _super);
    function CodeEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.updateValueFromStyle = function (style) {
            _this.valueFromStyleInput(style)
                .then(function (parsedStyle) {
                _this.setState({
                    value: parsedStyle
                });
            });
        };
        _this.getModeByParser = function () {
            var activeParser = _this.state.activeParser;
            if (activeParser && activeParser.title === 'SLD Style Parser') {
                return 'application/xml';
            }
            return 'application/json';
        };
        _this.valueFromStyleInput = function (style) {
            var activeParser = _this.state.activeParser;
            return new Promise(function (resolve, reject) {
                if (activeParser) {
                    resolve(activeParser.writeStyle(style));
                }
                else {
                    resolve(JSON.stringify(style, null, 2));
                }
            });
        };
        _this.styleFromValue = function (value) {
            var activeParser = _this.state.activeParser;
            return new Promise(function (resolve, reject) {
                if (activeParser) {
                    resolve(activeParser.readStyle(value));
                }
                else {
                    resolve(JSON.parse(value));
                }
            });
        };
        /**
         *
         */
        _this.onChange = function (editor, data, value) {
            _this.setState({
                value: value,
                invalidMessage: undefined
            });
            var onStyleChange = _this.props.onStyleChange;
            try {
                _this.styleFromValue(value)
                    .then(function (style) {
                    if (onStyleChange) {
                        onStyleChange(style);
                    }
                }).catch(function (err) {
                    _this.setState({
                        invalidMessage: err.message
                    });
                });
            }
            catch (err) {
                _this.setState({
                    invalidMessage: 'Error'
                });
            }
        };
        _this.onSelect = function (selection) {
            var _a = _this.props, parsers = _a.parsers, style = _a.style;
            if (parsers) {
                var activeParser = parsers.find(function (parser) { return parser.title === selection; });
                _this.setState({ activeParser: activeParser }, function () {
                    if (style) {
                        _this.updateValueFromStyle(style);
                    }
                });
            }
        };
        _this.handleOnChange = function (editor, data, value) {
            var delay = _this.props.delay;
            clearTimeout(_this.editTimeout);
            _this.editTimeout = setTimeout(function () {
                _this.onChange(editor, data, value);
            }, delay);
        };
        _this.getParserOptions = function () {
            var parserOptions = [
                React.createElement(Option, { key: "GeoStyler Style", value: "GeoStyler Style" }, "Geostyler Style")
            ];
            if (_this.props.parsers) {
                var additionalOptions = _this.props.parsers.map(function (parser) {
                    var title = parser.title;
                    return React.createElement(Option, { key: title, value: title }, title);
                });
                return parserOptions.concat(additionalOptions);
            }
            return parserOptions;
        };
        _this.onDownloadButtonClick = function () {
            var activeParser = _this.state.activeParser;
            var value = _this.state.value;
            var style = _this.props.style;
            if (style) {
                var fileName = style.name;
                var type = 'application/json;charset=utf-8';
                var title = activeParser && activeParser.title;
                if (title === 'SLD Style Parser') {
                    type = 'text/xml;charset=utf-8';
                    fileName += '.sld';
                }
                var blob = new Blob([value], { type: type });
                file_saver_1.saveAs(blob, fileName);
            }
        };
        _this.onCopyButtonClick = function () {
            var value = _this.state.value;
            _this.copyToClipboard(value);
        };
        /**
         * Copies the a value to the clipboard.
         * Credits: https://hackernoon.com/copying-text-to-clipboard-with-javascript-df4d4988697f
         *
         * @param {string} str The string to copy to the clipboard.
         */
        _this.copyToClipboard = function (str) {
            var locale = _this.props.locale;
            var el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            var selected = document.getSelection().rangeCount > 0 ? document.getSelection().getRangeAt(0) : false;
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
            antd_1.message.info(locale.styleCopied);
            if (selected) {
                document.getSelection().removeAllRanges();
                document.getSelection().addRange(selected);
            }
        };
        _this.editTimeout = null;
        _this.state = {
            value: '',
            hasError: false
        };
        return _this;
    }
    CodeEditor.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            activeParser: this.props.defaultParser
        }, function () {
            if (_this.props.style) {
                _this.updateValueFromStyle(_this.props.style);
            }
        });
    };
    CodeEditor.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        var diffProps = !_isEqual(this.props, nextProps);
        var diffState = !_isEqual(this.state, nextState);
        return diffProps || diffState;
    };
    CodeEditor.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (this.props.style && !_isEqual(this.props.style, prevProps.style)) {
            this.updateValueFromStyle(this.props.style);
        }
    };
    CodeEditor.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true
        });
    };
    CodeEditor.prototype.render = function () {
        var _a = this.props, locale = _a.locale, showSaveButton = _a.showSaveButton, showCopyButton = _a.showCopyButton;
        var activeParser = this.state.activeParser;
        var _b = this.state, hasError = _b.hasError, value = _b.value;
        if (hasError) {
            return React.createElement("h1", null, "An error occured in the CodeEditor UI.");
        }
        return (React.createElement("div", { className: "gs-code-editor" },
            React.createElement("div", { className: "gs-code-editor-toolbar" },
                locale.formatSelectLabel,
                ": ",
                React.createElement(antd_1.Select, { className: "gs-code-editor-format-select", style: { width: 300 }, onSelect: this.onSelect, value: activeParser ? activeParser.title : 'GeoStyler Style' }, this.getParserOptions())),
            React.createElement(react_codemirror2_1.UnControlled, { className: "gs-code-editor-codemirror", value: value, autoCursor: false, options: {
                    gutters: ['CodeMirror-lint-markers'],
                    lint: true,
                    mode: this.getModeByParser(),
                    lineNumbers: true,
                    lineWrapping: true
                }, onChange: this.handleOnChange }),
            React.createElement("div", { className: "gs-code-editor-errormessage" }, this.state.invalidMessage),
            React.createElement("div", { className: "gs-code-editor-bottombar" },
                !showCopyButton ? null :
                    React.createElement(antd_1.Button, { className: "gs-code-editor-copy-button", type: "primary", onClick: this.onCopyButtonClick }, locale.copyButtonLabel),
                !showSaveButton ? null :
                    React.createElement(antd_1.Button, { className: "gs-code-editor-download-button", type: "primary", onClick: this.onDownloadButtonClick }, locale.downloadButtonLabel))));
    };
    CodeEditor.componentName = 'CodeEditor';
    CodeEditor.defaultProps = {
        locale: en_US_1.default.GsCodeEditor,
        delay: 500,
        showSaveButton: false,
        showCopyButton: false
    };
    return CodeEditor;
}(React.Component));
exports.CodeEditor = CodeEditor;
exports.default = LocaleWrapper_1.localize(CodeEditor, CodeEditor.componentName);
//# sourceMappingURL=CodeEditor.js.map